import { render } from "./TrialBalanceTable.vue?vue&type=template&id=fa7cccd8&scoped=true"
import script from "./TrialBalanceTable.vue?vue&type=script&lang=js"
export * from "./TrialBalanceTable.vue?vue&type=script&lang=js"

import "./TrialBalanceTable.vue?vue&type=style&index=0&id=fa7cccd8&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa7cccd8"]])

export default __exports__